import React, {useState} from "react";
import * as prosConnect from "./ProsConnect";
import {
    ATTR_EXPORT_WEB_REPORT, ATTR_TEXT,
    FEAT_PROMPT_REPORT_REC, FEAT_WEB_UPDATED,
    featureEnabled, showingIdentifiers,
    STR_NO
} from "./ProsConnect";
import {getCopyMoveManager} from "./CopyMoveManager";
import {openUrl, PRODECT_DEFAULT_EMAIL_MSG} from "./ProsCommonUi";
import BasicButton from "../components/BasicButton";
import Spacer from "../components/Spacer";
import TextInput from "../components/TextInput";
import prosAppNotif, {prosAppNotifDismiss} from "./ProsAppNotif";
import DropdownMenu from "../components/DropdownMenu";
import BasicModal from "../components/BasicModal";
import {OpenReportSettingsBasicModal} from "./ProsReportSettingsDialog";
import {setHelpContext} from "./HelpManager";


const STORED_EMAIL_RECEIVER = "Prodect-rec-email";

export default function ReportSearchMenu (props) {
    const [email, setEmail] = useState('')
    const [textForUser, setTextForUser] = useState('')
    const menuItems = getReportOrSearchMenuItems(props.report)

    function closePopUpMenu(callParent=true) {
        setEmail('')
        setTextForUser('')
    }

    const makeAndOpenReport = async (report)=> {
        props.notif("Pyydetään raporttia...", false, false, true)
        //setLoadingText("Pyydetään raporttia...")
        //setShowReportLoading(true)
        let url = await prosConnect.awaitShowReport(report);
        closePopUpMenu()
        props.notif("Avataan raportti selaimella...")
        //setShowReportLoading(false)
        if (url) {
            openUrl(url);
        } else {
            props.notif("Raportin teko epäonnistui", true, false)
        }
    }

    // function renderReportLoading() {
    //     if (!showReportLoading) {
    //         return null
    //     }
    //     return <LoadingAnimation size={"lg"} text={loadingText} color={"var(--color-light)"} mask />
    // }

    // const openWebLink = async(search)=> {
    //     setGeneratingReport(true)
    //     let response = await prosConnect.getActiveProject().awaitMakeWebReport(
    //         search.obj_id,
    //         prosConnect.REPORT_TYPE_SEARCH,
    //         undefined,
    //         undefined,
    //         false);
    //     setGeneratingReport(false)
    //     if (response.hasOwnProperty('url')) {
    //         openUrl(response.url)
    //     } else {
    //         props.notif("Virhe - raportin teko epäonnistui");
    //     }
    // }

    // function renderGeneratingReport() {
    //     if (generatingReport) {
    //         return <LoadingAnimation size={"lg"} text="Tehdään haku raporttia..."/>
    //     }
    // }

    const makeAndUpdateReport = async (report, reportType, pdf = false)=> {

        function hideSendPopUps(self) {
            //setShowReportLoading(false)
            closePopUpMenu()
        }

        if (reportType === prosConnect.REPORT_TYPE_NUMBERING) {
            //setShowReportLoading(true)
            //setLoadingText("Numeroidaan raporttia...")
        } else {
            if (email) {
                localStorage.setItem(STORED_EMAIL_RECEIVER, email);
            }
            if (pdf) {
                hideSendPopUps(this);
                props.notif("PDF raportin pyyntö lähetetty - linkki lähetetään sähköpostissa", false, true)
            }
        }
        let reportId = report.obj_id;
        let emailStr = email ? email : prosConnect.getUserEmail();
        let emailReceivers = prosConnect.replaceAll(emailStr, ' ', '');
        emailReceivers = prosConnect.replaceAll(emailReceivers, ';', ',').split(',');
        let emailMsg = textForUser.length > 0 ?
            textForUser: PRODECT_DEFAULT_EMAIL_MSG

        let notifText = 'Odotetaan ' +
            ((reportType === prosConnect.REPORT_TYPE_NUMBERING) ?
                "numerointia" : "raporttia")
        props.notif(notifText, false, false, true)

        let response = await prosConnect.getActiveProject().awaitMakeWebReport(
            reportId,
            reportType,
            emailReceivers,
            emailMsg,
            pdf)
        props.notif('Raportti tehty', false, false, false)

        prosConnect.prosLog("Response to report req", response);
        if (!response || response.response !== "OK") {
            props.notif(reportType === prosConnect.REPORT_TYPE_NUMBERING ?
                "Raportin numerointi epäonnistui !":
                "Raportin teko epäonnistui !")
            hideSendPopUps(this)
            return
        }
        if (pdf) {
            // notif above only if would fail - hide popup's already before
        } else {
            hideSendPopUps(this);
            if (reportType === prosConnect.REPORT_TYPE_NUMBERING) {
                props.notif("Numerointi tehty");
                await prosConnect.getActiveProject().awaitRefreshProjectObjectsFromAws();
                return;
            }
            if (response.hasOwnProperty('url')) {
                openUrl(response.url);
            } else {
                props.notif("Virhe - raportin teko epäonnistui");
            }
        }
    }

    const deleteReport = async (report)=> {
        closePopUpMenu()
        await prosConnect.getActiveProject().awaitRemoveItem(report, true)
        if(props.updateModal) props.updateModal(report)
    }

    // function renderTitleContent(stagIndex) {
    //     let titlesTable = [];
    //     stagIndex.forEach((tag) => {
    //         let title = prosConnect.getActiveProject().getAttr(tag);
    //
    //         const [titles, onOff] = title.split(';');
    //         if (titles && onOff) {
    //             let onUse = false;
    //             if (onOff.includes("Y")) {
    //                 onUse = true;
    //             }
    //             titlesTable.push({
    //                 statement: titles,
    //                 checked: onUse,
    //                 stag: tag,
    //             });
    //         } else {
    //             return null
    //         }
    //     })
    //     return titlesTable
    // }

    // function renderOnOffContent(item) {
    //     let titlesTable = renderTitleContent(item);
    //     let radioList = [];
    //     titlesTable.forEach((tag) => {
    //         radioList.push({
    //             titles: tag.statement,
    //             onOff: tag.checked,
    //             stag: tag.stag,
    //         })
    //     });
    //     return radioList;
    //
    // }

    function renderMakeReportMenu(report, reportType, menuText, feature, pdf, icon) {
        if (!prosConnect.getActiveProject().mayShareWebReport(feature)) {
            return null
        }
        return <BasicButton
            btnClass={"2nd"}
            label={menuText}
            icon={icon}
            action={()=> makeAndUpdateReport(report, reportType, pdf)}
        />
    }

    function renderWebReportMenu(report) {
        if (featureEnabled(FEAT_PROMPT_REPORT_REC)) {
            if (prosConnect.isReportType(report)) {
                return <div className={"btn-list"}>
                    {renderMakeReportMenu(report, prosConnect.REPORT_TYPE_UPDATED, 'Päivittyvä raportti', FEAT_WEB_UPDATED, false, 'sync')}
                    {renderMakeReportMenu(report, prosConnect.REPORT_TYPE_HISTORY, 'Tallennettu nykytilanne', undefined, false, 'calendar-today')}
                    {renderMakeReportMenu(report, prosConnect.REPORT_TYPE_HISTORY, 'PDF-raportti', undefined, true,  'document-text')}
                </div>
            } else {
                return <div className={"btn-list"}>
                    {renderMakeReportMenu(report, prosConnect.REPORT_TYPE_SEARCH, 'Web-raportti', FEAT_WEB_UPDATED, false, 'link')}
                    {renderMakeReportMenu(report, prosConnect.REPORT_TYPE_HISTORY, 'PDF-raportti', undefined, true, 'document-text')}
                </div>
            }
        } else {
            return <div className={"btn-list"}>
                {renderMakeReportMenu(report, prosConnect.REPORT_TYPE_HISTORY, 'Lähetä PDF-raportti', undefined, true,'document-text')}
            </div>
        }
    }

    function renderMessageToReceiver() {
        let activeProject = prosConnect.getActiveProject()
        if (!featureEnabled(FEAT_PROMPT_REPORT_REC) || activeProject.getAttr(ATTR_EXPORT_WEB_REPORT) === STR_NO) {
            return null
        }
        return  <TextInput
            label={"Viesti käyttäjälle"}
            value={textForUser}
            multiline={3}
            onChange={(val) => setTextForUser(val)}
        />
    }

    function renderDeleteReportOrSearch(listObj) {
        if (prosConnect.isReportType(listObj)) {
            return <>
                <h3>Poista raportti: {listObj[ATTR_TEXT]}</h3>
                <p>Oletko varma että haluat poistaa raportin ja kaikki sen kirjaukset, kommentit ja liitteet?<br/>
                    Tiedot saa palautettua osaprojektin asetukset / palauta tiedot- toiminnolla.
                </p>
            </>
        }
        return <>
            <h3>Poista hakuraportti: {listObj[ATTR_TEXT]}</h3>
            <p>Oletko varma että haluat poistaa hakuraportin?<br/>
                <strong className={"color-2nd"}>Poistettuja tietoja ei voi palauttaa toiminnon jälkeen.</strong>
            </p>
        </>
    }

    const saveReportTextEdit = async(report, txt)=> {
        await prosConnect.getActiveProject().awaitUpdateItemAttrs(report, {[ATTR_TEXT]: txt}, true)
        closePopUpMenu()
    }

    function showEmail(report) {
        let storedReceiver = localStorage.getItem(STORED_EMAIL_RECEIVER)
        setEmail(storedReceiver && storedReceiver !== "undefined" ? storedReceiver : '')
        //Todo Sampo, will not render content if using setState callback
        return <>
            <TextInput
                type={"email"}
                label={"Sähköpostiosoite"}
                value={email}
                onChange={(val) => {
                    setEmail(val)
                    if(val === '') localStorage.removeItem(STORED_EMAIL_RECEIVER)
                }}
                autoFocus
            />
            <Spacer/>
            {renderMessageToReceiver(report)}
            <Spacer/>
            {renderWebReportMenu(report)}
        </>
    }

    function developerMenuItem(obj) {
        return {
            text: "Dump obj",
            icon: "search",
            action: ()=> {
                prosConnect.dumpProsObj(obj)
                closePopUpMenu()
            }
        }
    }

    function getReportOrSearchMenuItems(listObj) {
        let activeProject = prosConnect.getActiveProject()
        if (getCopyMoveManager().isCopyOrMoveMode()) {
            return [{
                text: "Peru kopiointi/siirto",
                icon: "cancel",
                action: ()=> cancelMoveOrCopy()
            }]
        }
        let dropdownItems = []
        let mayShowWebReportMenu = featureEnabled(FEAT_PROMPT_REPORT_REC)
            && activeProject.getAttr(ATTR_EXPORT_WEB_REPORT) !== STR_NO
        let sendWebReportMenuItem = {
            text: "Lähetä",
            icon: "send",
            action: ()=> {
                BasicModal('Lähetä raportti', showEmail(listObj), {
                    btnType: 'prompt'
                })
            },
            btnType: "prompt"
        }
        const canEditReport = prosConnect.hasPermissionTo("editProject", undefined, undefined, false)
        if (prosConnect.isReportType(listObj) && canEditReport) {
            dropdownItems.push({
                text: "Muokkaa nimeä",
                icon: "edit",
                action: ()=> {
                    BasicModal('Muokkaa raportin nimeä', renderReportTextEdit(listObj), {
                        action: ()=> {
                            let txt = document.getElementById("prodect-edit-txt").value
                            if(txt.length < 1) prosAppNotif('Liian lyhyt nimi')
                            else saveReportTextEdit(listObj, txt)
                        }
                    })
                },
                btnType: "prompt"
            })
            if (showingIdentifiers() && canEditReport) {
                dropdownItems.push({
                    text: "Numeroi raportti ja kirjaukset",
                    icon: "list-numbered",
                    action: ()=> makeAndUpdateReport(listObj, prosConnect.REPORT_TYPE_NUMBERING)
                })
            }
            if (mayShowWebReportMenu) {
                dropdownItems.push({
                    text: "Esikatsele web-raporttia",
                    icon: "inspect",
                    action: ()=> makeAndOpenReport(listObj)
                })
                dropdownItems.push(sendWebReportMenuItem)
            }
            if (canEditReport) {
                dropdownItems.push({
                    text: "Tulostusasetukset",
                    icon: "sliders",
                    action: ()=> {
                        setHelpContext('reportSettings')
                        OpenReportSettingsBasicModal({report: listObj})
                    },
                    btnType: "prompt"
                })
                dropdownItems.push(renderCopyOrMoveReport(false, listObj))
                dropdownItems.push(renderCopyOrMoveReport(true, listObj))
            }
        } else {
            // Search menu
           if(canEditReport) dropdownItems.push({
                text: "Muokkaa hakua",
                icon: "edit",
                action: ()=> props.gotoPage('editSearch', true, listObj.obj_id)
            })
            if (mayShowWebReportMenu) {
                dropdownItems.push(sendWebReportMenuItem)
            }
        }
        if(canEditReport) dropdownItems.push(renderDeleteReport(listObj))
        if (prosConnect.userHasDebugMenu()) dropdownItems.push(developerMenuItem(listObj))
        return dropdownItems
    }

    function renderDeleteReport(report) {
        return {
            text: 'Poista',
            icon: "bin",
            action: ()=> {
                BasicModal('Vahvista', renderDeleteReportOrSearch(report), {
                    action: ()=> {
                        deleteReport(report)
                    },
                    callback: ()=> {
                        prosAppNotif('Raporttia poistetaan')
                    },
                    btnText: 'Poista',
                    btnType: 'fatal'
                })
            },
            btnType: "prompt"
        }
    }

    function cancelMoveOrCopy() {
        getCopyMoveManager().cancelOperations()
        prosAppNotifDismiss()
        closePopUpMenu()
    }

    function setCopyReportMode(report, isMove) {
        closePopUpMenu()
        if (isMove) {
            getCopyMoveManager().markMoveSource(report);
        } else {
            getCopyMoveManager().markCopySource(report);
        }
        props.notif(['Siirto/kopiointi aktivoitu', 'Valitse osaprojekti johon lisätään'],
            'notice', false, false, {
                action: ()=> cancelMoveOrCopy(),
                text: 'Peru toiminto',
                icon: 'cancel'
        })
    }

    function renderCopyOrMoveReport(isMove, listObj) {
        let title = isMove ?
            "Siirrä raportti toiseen projektiin" :
            "Kopioi raportti"
        return {
            text: title,
            icon: isMove ? "document-move" : "copy",
            action: ()=> setCopyReportMode(listObj, isMove)
        }
    }

    function renderReportTextEdit(report) {
        return <TextInput
            id={"prodect-edit-txt"}
            value={report[ATTR_TEXT]}
            autoFocus
        />
    }

    if(!menuItems || menuItems.length < 1) return null
    //props.text is only used in search report dropdown
    return <DropdownMenu
        values={menuItems}
        className={"ui-dropdown-align-right"}
        text={props.text || false}
        icon={props.icon || "ellipsis-v"}
        hideArrow
        btnClass={"3rd"}
        disabled={!prosConnect.getActiveProject().isProjectActive()}
        notifMsg={"Osaprojekti on arkistoitu"}
        customTag={'span'}
        active={props.text}
        openDropdownCallback={()=>{
            if(props.openDropdownCallback) props.openDropdownCallback()
            setHelpContext('reportMenu')
        }}
        closeDropdownCallback={()=>{
            if(props.closeDropdownCallback) props.closeDropdownCallback()
            setHelpContext('closePopup')
        }}

    />
}
